// src/i18n-loader.ts
import i18n, { type AppLocale } from './i18n';

// Alle JSON-Dateien unter /locales dynamisch importieren (Vite)
const modules = import.meta.glob('./locales/*/*.json', { eager: false });

export async function loadLocaleMessages(locale: AppLocale) {
  const entries = Object.entries(modules).filter(([p]) => p.includes(`/locales/${locale}/`));

  const bundle: Record<string, any> = {};
  for (const [path, loader] of entries) {
    const mod: any = await (loader as any)();
    const ns = path.split('/').pop()!.replace('.json', ''); // z. B. "auth"
    bundle[ns] = mod.default ?? mod;
  }

  i18n.global.setLocaleMessage(locale, bundle);
}

export function setLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
  localStorage.setItem('language', locale);
  document.documentElement.setAttribute('lang', locale);
}
